import validate from "/Users/macgitlabrunner1/builds/EFFy8Dyq/5/web-applications/revagency-com/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}